import styled from "styled-components";

export const AboutContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50vw;
`;
